import { useMutation, useQueryClient } from '@tanstack/react-query'

import { showErrorToast } from 'common/api/helpers'
import { successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { createLanguageRule } from '../api'
import { languageRulesKeys } from '../queryKeys'

const useCreateLanguageRuleMutation = () => {
  const queryClient = useQueryClient()

  const accountId = useAppSelector((state) => state.authStates.accountId)

  return useMutation({
    mutationFn: createLanguageRule,
    onSuccess: () => {
      successToast('Language rule has been successfully added')

      queryClient.invalidateQueries({
        queryKey: languageRulesKeys.list(accountId),
      })
    },
    onError: (error) => {
      showErrorToast(error)
    },
  })
}

export default useCreateLanguageRuleMutation
